import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../../../../redux/store';
import { POPUP } from '../../../../redux/types';

import { IErrorPopup } from '../../types/IErrorPopup';

import Icon from '../../icon/icon';
import PopupWrapper from '../popupWrapper/popupWrapper';

import './serverError.scss';

const ServerError: React.FC<IErrorPopup> = () => {
  const dispatch = useDispatch();

  const serverError = useSelector((state: RootState) => state.serverError.serverError);
  const serverErrorMessage = useSelector((state: RootState) => state.serverError.message);

  const closeServerError = () => {
    dispatch({ type: POPUP.CLOSE_SERVER_ERROR });
  };

  return serverError && (
    <PopupWrapper className='error-popup-style' onClose={closeServerError}>
      <Icon name='far fa-circle-exclamation' className='danger-icon' />
      <span>{serverErrorMessage}</span>
    </PopupWrapper>
  );
};

export default ServerError;